import { createSlice } from "@reduxjs/toolkit";
import {
  createDynamicThunk,
  addApiCases,
} from "../../../../../service/requestHandler";

export const treeMapAccOpenApi = createDynamicThunk(
  "treeMapAccOpenApi",
  "/report/api/v1/circularNineComplianceTreeMapping/getCircular09TreeMappedData",
  ["accountName"],
  "GET"
);

export const treeMapOnPremiseAccOpenApi = createDynamicThunk(
  "treeMapOnPremiseAccOpenApi",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getCircular09OnPremiseTreeMappedData"
);

export const treeMapComplianceDrillDown = createDynamicThunk(
  "treeMapComplianceDrillDown",
  "/report/api/v1/circularNineComplianceTreeMapping/getComplianceTreeMappedListWithSearch",
  ["accountName", "articleDescription", "pageNumber", "itemsPerPage"]
);

export const treeMapComplianceDrillDownCount = createDynamicThunk(
  "treeMapComplianceDrillDownCount",
  "/api/v1/circularNineComplianceTreeMapping/getComplianceTreeMappedListWithSearchCount/${dataTree.accountName}/${dataTree.articleDescription}"
);

export const treeMapNonComplianceDrillDown = createDynamicThunk(
  "treeMapNonComplianceDrillDown",
  "/report/api/v1/circularNineComplianceTreeMapping/getNonComplianceTreeMappedListWithSearch",
  ["accountName", "articleDescription", "pageNumber", "itemsPerPage"]
);

export const treeMapNonComplianceDrillDownCount = createDynamicThunk(
  "treeMapNonComplianceDrillDownCount",
  "/api/v1/circularNineComplianceTreeMapping/getNonComplianceTreeMappedListWithSearchCount/${dataTree.accountName}/${dataTree.articleDescription}"
);

export const treeMapNotApplicableDrillDown = createDynamicThunk(
  "treeMapNotApplicableDrillDown",
  "/report/api/v1/circularNineComplianceTreeMapping/getNotApplicableCircularNineMappedListWithSearch",
  ["accountName", "articleDescription", "pageNumber", "itemsPerPage"]
);

export const treeMapNotApplicableDrillDownCount = createDynamicThunk(
  "treeMapNotApplicableDrillDownCount",
  "/api/v1/circularNineComplianceTreeMapping/getNotApplicableCircularNineMappedListWithSearchCount/${dataTree.accountName}/${dataTree.articleDescription}"
);

export const graphtDataApi = createDynamicThunk(
  "graphtDataApi",
  "/report/api/v1/conformancePack/TRMG/GraphData",
  ["packName"]
);

export const getCountForNonComplianceAPI = createDynamicThunk(
  "getCountForNonComplianceAPI",
  "/api/v1/conformancePack/TRMG/getCountForNonCompliance",
  ["packName", "accountName"]
);

export const getListForNonComplianceAPI = createDynamicThunk(
  "getListForNonComplianceAPI",
  "/api/v1/conformancePack/TRMG/getSearchNonCompliancesRules/list",
  ["packName", "accountName", "pageNumber", "itemsPerPage"]
);

export const getCompliantListAPI = createDynamicThunk(
  "getCompliantListAPI",
  "/api/v1/conformancePack/TRMG/getSearchCompliancesRules/list",
  ["packName", "accountName", "pageNumber", "itemsPerPage"]
);

export const getCompliantCountAPI = createDynamicThunk(
  "getCompliantCountAPI",
  "/api/v1/conformancePack/TRMG/getCountForTrmgCompliance",
  ["packName", "accountName"]
);

export const getNotApplicableListAPI = createDynamicThunk(
  "getNotApplicableListAPI",
  "/api/v1/conformancePack/TRMG/GetNotApplicable/list",
  ["packName", "accountName", "pageNumber", "itemsPerPage"]
);

export const getNotApplicableCountAPI = createDynamicThunk(
  "getNotApplicableCountAPI",
  "/api/v1/conformancePack/TRMG/getCountForNotApplicable",
  ["packName", "accountName"]
);

export const OnPremiseTableListAPI = createDynamicThunk(
  "OnPremiseTableListAPI",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/getWithCircular09ListAndPagination",
  ["pageNumber", "itemsPerPage"]
);

export const OnPremiseRATableListAPI = createDynamicThunk(
  "OnPremiseRATableListAPI",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getWithOutCircular09ListAndPagination",
  ["pageNumber", "itemsPerPage"]
);

export const OnpremiseChartAPI = createDynamicThunk(
  "OnpremiseChartAPI",
  "/riskAssessment/api/v1/circularOnPremisesRiskAssessment/nonComplianceByAccountIdGraphForOnPremisesWithC09"
);

export const OnpremiseRAChartAPI = createDynamicThunk(
  "OnpremiseRAChartAPI",
  "/riskAssessment/api/v1/riskAssessmentDashboard/nonComplianceByAccountIdGraphForOnPremisesWithoutC09"
);

export const OnPremiseNonCompliantTableListAPI = createDynamicThunk(
  "OnPremiseNonCompliantTableListAPI",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getNonCompliantListForRiskAssessmentForDashboard",
  ["pageNumber", "itemsPerPage"]
);

export const OnPremiseCompliantTableListAPI = createDynamicThunk(
  "OnPremiseCompliantTableListAPI",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getCompliantListForRiskAssessmentForDashboard",
  ["pageNumber", "itemsPerPage"]
);

export const OnPremiseNotApplicableTableListAPI = createDynamicThunk(
  "OnPremiseNotApplicableTableListAPI",
  "riskAssessment/api/v1/riskAssessmentDashboard/getNotApplicableListForRiskAssessmentForDashboard",
  ["pageNumber", "itemsPerPage"]
);

export const OnPremisePartiallyCompliantTableListAPI = createDynamicThunk(
  "OnPremisePartiallyCompliantTableListAPI",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getPartiallyCompliantListForRiskAssessmentForDashboard",
  ["pageNumber", "itemsPerPage"]
);

export const getDetailsofOnPremise = createDynamicThunk(
  "getDetailsofOnPremise",
  "/riskAssessment/api/v1/riskAssessmentDashboard/getCircularNineOnPremiseCommentList",
  ["complianceId"],
  "GET"
);

export const initialState = {
  treeMapAccOpenApiData: [],
  treeMapAccOpenApiLoading: false,
  treeMapOnPremiseAccOpenApiData: [],
  treeMapOnPremiseAccOpenApiLoading: false,
  treeMapComplianceDrillDownData: [],
  treeMapComplianceDrillDownLoading: false,
  treeMapComplianceDrillDownCountData: [],
  treeMapComplianceDrillDownCountLoading: false,
  treeMapNonComplianceDrillDownData: [],
  treeMapNonComplianceDrillDownLoading: false,
  treeMapNonComplianceDrillDownCountData: [],
  treeMapNonComplianceDrillDownCountLoading: false,
  treeMapNotApplicableDrillDownData: [],
  treeMapNotApplicableDrillDownLoading: false,
  treeMapNotApplicableDrillDownCountData: [],
  treeMapNotApplicableDrillDownCountLoading: false,
  graphtDataApiData: [],
  graphtDataApiDataLoading: false,
  getCountForNonComplianceAPIData: [],
  getCountForNonComplianceAPILoading: false,
  getListForNonComplianceAPIData: [],
  getListForNonComplianceAPILoading: false,
  getCompliantListAPIData: [],
  getCompliantListAPILoading: false,
  getCompliantCountAPIData: [],
  getCompliantCountAPILoading: false,
  getNotApplicableListAPIData: [],
  getNotApplicableListAPILoading: false,
  getNotApplicableCountAPIData: [],
  getNotApplicableCountAPILoading: false,
  OnPremiseTableListAPIData: [],
  OnPremiseTableListAPILoading: false,
  OnPremiseRATableListAPIData: [],
  OnPremiseRATableListAPILoading: false,
  OnpremiseChartAPIData: [],
  OnpremiseChartAPILoading: false,
  OnpremiseRAChartAPIData: [],
  OnpremiseRAChartAPILoading: false,
  OnPremiseNonCompliantTableListAPIData: [],
  OnPremiseNonCompliantTableListAPILoading: false,
  OnPremiseCompliantTableListAPIData: [],
  OnPremiseCompliantTableListAPILoading: false,
  OnPremiseNotApplicableTableListAPIData: [],
  OnPremiseNotApplicableTableListAPILoading: false,
  OnPremisePartiallyCompliantTableListAPIData: [],
  OnPremisePartiallyCompliantTableListAPILoading: false,
  getDetailsofOnPremiseData: [],
  getDetailsofOnPremiseLoading: false,
};

export const Circular9Slice = createSlice({
  name: "Circular9Slice",
  initialState,
  reducers: {
    resetCircular9Slice: () => {
      return initialState;
    },
    setClickAble: (state, action) => {
      state.clickAble = action.payload;
    },
    resetdrillDownData: (state) => {
      state.trmgComplianceDrillDown = [];
      state.trmgComplianceDrillDownCount = [];
      state.trmgNonComplianceDrillDown = [];
      state.trmgNonComplianceDrillDownCount = [];
      state.trmgNotApplicableDrillDown = [];
      state.trmgNotApplicableDrillDownCount = [];
    },
  },
  extraReducers: (builder) => {
    addApiCases(builder, treeMapAccOpenApi, "treeMapAccOpenApiData");
    addApiCases(builder, treeMapOnPremiseAccOpenApi, "treeMapAccOpenApiData");
    addApiCases(
      builder,
      treeMapComplianceDrillDown,
      "treeMapComplianceDrillDownData"
    );
    addApiCases(
      builder,
      treeMapComplianceDrillDownCount,
      "treeMapComplianceDrillDownCountData"
    );
    addApiCases(
      builder,
      treeMapNonComplianceDrillDown,
      "treeMapNonComplianceDrillDownData"
    );
    addApiCases(
      builder,
      treeMapNonComplianceDrillDownCount,
      "treeMapNonComplianceDrillDownCountData"
    );
    addApiCases(
      builder,
      treeMapNotApplicableDrillDown,
      "treeMapNotApplicableDrillDownData"
    );
    addApiCases(
      builder,
      treeMapNotApplicableDrillDownCount,
      "treeMapNotApplicableDrillDownCountData"
    );
    addApiCases(builder, graphtDataApi, "graphtDataApiData");
    addApiCases(
      builder,
      getCountForNonComplianceAPI,
      "getCountForNonComplianceAPIData"
    );
    addApiCases(
      builder,
      getListForNonComplianceAPI,
      "getListForNonComplianceAPIData"
    );
    addApiCases(builder, getCompliantListAPI, "getCompliantListAPIData");
    addApiCases(builder, getCompliantCountAPI, "getCompliantCountAPIData");
    addApiCases(
      builder,
      getNotApplicableListAPI,
      "getNotApplicableListAPIData"
    );
    addApiCases(
      builder,
      getNotApplicableCountAPI,
      "getNotApplicableCountAPIData"
    );
    addApiCases(builder, OnPremiseTableListAPI, "OnPremiseTableListAPIData");
    addApiCases(
      builder,
      OnPremiseRATableListAPI,
      "OnPremiseRATableListAPIData"
    );
    addApiCases(builder, OnpremiseChartAPI, "OnpremiseChartAPIData");
    addApiCases(builder, OnpremiseRAChartAPI, "OnpremiseRAChartAPIData");
    addApiCases(
      builder,
      OnPremiseNonCompliantTableListAPI,
      "OnPremiseNonCompliantTableListAPIData"
    );
    addApiCases(
      builder,
      OnPremiseCompliantTableListAPI,
      "OnPremiseCompliantTableListAPIData"
    );
    addApiCases(
      builder,
      OnPremiseNotApplicableTableListAPI,
      "OnPremiseNotApplicableTableListAPIData"
    );
    addApiCases(
      builder,
      OnPremisePartiallyCompliantTableListAPI,
      "OnPremisePartiallyCompliantTableListAPIData"
    );
    addApiCases(builder, getDetailsofOnPremise, "getDetailsofOnPremiseData");
  },
});

export const { resetCircular9Slice, setClickAble, resetdrillDownData } =
  Circular9Slice.actions;
export default Circular9Slice.reducer;
